// interface BooleanFilter {
//     operator: ComparisonExpressions.equals | ComparisonExpressions.notEquals;
//     field: FieldNames;
//     value: boolean;
// }

////////

// // // //
// Future options / language:
// is
// is not
// is before
// is after
// is in the last
// is not in the last
// is in the next
// is not in the next
// occurs at
// occurs before
// occurs after
// is among the
// is not among the
// did change
// did not change
// is blank
// is not blank
// // // //
// MORE:
// is
// is not
// contains
// does not contain
// starts with
// does not start with
// ends with
// does not end with
// matches
// does not match
// did change
// did not change
// is blank
// is not blank

// FOR STRING OPERATOR:
// TODO - add these, or most of these?
// is
// is not
// contains
// does not contain
// starts with
// does not start with
// ends with
// does not end with
// matches
// does not match
// did change
// did not change
// is blank
// is not blank
//////

// TODO - rename to CompoundOperator + CompoundOperators
enum CompoundExpressions {
    and = "and",
    or = "or",
}
export type CompoundExpression = `${CompoundExpressions}`;

export interface CompositeFilter {
    operator: CompoundExpression;
    filters: Filter[]; // An array of filters that this filter encapsulates
    field?: never;
    value?: never;
}

// TODO - clean up this implementation
// interface PrimitiveFilter {
//     operator: "equals" | "notEquals";
//     field: string;
//     value: string | number | boolean;
//     filters?: never;
// }

// interface StringFilter {
//     operator: "like" | "ilike" | "endsWith" | "startsWith";
//     field: string;
//     value: string;
//     filters?: never;
// }

// interface ArrayFilter {
//     operator: "in" | "not-in" ;
//     field: string;
//     value: string[] | number[];
//     filters?: never;
// }

// interface NumberFilter {
//     operator: "gt" | "lt" | "gte" | "lte";
//     field: string;
//     value: number;
//     filters?: never;
// }

// export type BasicFilter =
//     | PrimitiveFilter
//     | StringFilter
//     | ArrayFilter
//     | NumberFilter;

// NOTE - the Array<string | number> type is just here for type safety.
// It's unlikely that we'll mix string + number arrays in a single filter value
type FilterValue =
    | string
    | number
    | boolean
    | string[]
    | number[]
    | Array<string | number>
    | null;

export interface BasicFilter {
    // operator: Omit<FilterOperator, "and" | "or">;
    operator: FilterOperator; // TODO - set this up so it doesn't include AND + OR values
    field: string;
    value: FilterValue;
    filters?: never;
}

export type Filter = CompositeFilter | BasicFilter;

// // // //
// API Requests

export enum SortDirections {
    asc = "asc",
    desc = "desc",
    none = "",
}
export type SortDirection = `${SortDirections}`;

// Sort API data
export interface SortQuery {
    field: string;
    direction: SortDirection;
}

// Paginate API data
export interface PaginationQuery {
    page: number;
    perPage: number;
}

export enum AggregateFunctions {
    Sum = "sum",
    Avg = "avg",
    Min = "min",
    Max = "max",
    // Count = "count",
}

export enum AggregateQueryInterval {
    day = "day",
    week = "week",
    month = "month",
    quarter = "quarter",
    year = "year",
}

export enum AggregateQueryMode {
    stock = "stock",
    flow = "flow",
}

export interface AggregateQuery {
    groupBy: string; // NOTE - this should be a value from FieldKeys enum
    aggregateFunction: AggregateFunctions;
    interval?: AggregateQueryInterval;
    groupLimit?: number;
    mode?: AggregateQueryMode;

    // mode = "stock"
    // Pick one reading per bucket (latest in‐window, or latest per day/week…)
    // ↦ Gauge ⇄ Balance ⇄ Snapshot ⇄ Point‑in‑time.

    // mode = "flow"
    // Aggregate all readings that fall inside each bucket (sum/avg/min/max).
    // ↦ Counter ⇄ Transaction ⇄ Additive ⇄ Period‑to‑date.
}

// Filter + Aggregate + Sort + Paginate API data
// ENHANCEMENT - SortQuery and PaginationQuery should be optional as well
export interface ApiQuery {
    name?: string;
    filter?: Filter;
    aggregate?: AggregateQuery;
    fields?: string[];
    sort: SortQuery;
    pagination: PaginationQuery;
}

// // // //
// API Responses

// Response from API with Pagination
export interface PaginationState {
    page: number;
    perPage: number;
    pageCount: number;
    resultCount: number;
}

export interface QueryResponse<DataModel> {
    results: DataModel[];
    filter?: Filter;
    sort: SortQuery;
    pagination: PaginationState;
}

// // // //
// ApiQueryExample
export interface ApiQueryExample {
    key: string;
    content: Content;
    query: ApiQuery;
}

// // // //

export enum FilterTypes {
    String = "string",
    Float = "float",
    PositiveFloat = "positiveFloat",
    NegativeFloat = "negativeFloat",
    Integer = "integer",
    PositiveInteger = "positiveInteger",
    NegativeInteger = "negativeInteger",
    Percent = "percent",
    // // // //
    // Date Filter Types
    Date = "date",
    RelativeDate = "relativeDate",
    RelativePastDate = "relativePastDate",
    RelativeFutureDate = "relativeFutureDate",
    // // // //
    Boolean = "boolean",
    StringSingleSelect = "stringSingleSelect",
    Search = "search",
    Dollar = "Dollar",
    // PositiveDollar = "PositiveDollar",
    // NegativeDollar = "NegativeDollar",
    // TODO - add stringMultiSelect
    // TODO - add "dollar" - or "usdPositiveInteger"? Can prob be solved with Content.icon, no need for this much specificity
    // TODO - add "DatetimeMonthPicker"?
    // TODO - add "DatetimeDayPicker"?
    // TODO - add "DatetimeYearPicker"?
    // TODO - add better support for relative datetimes (i.e. last week / last 2 weeks / last month / last 3 months / last 6 months / etc.)
}
export type FilterType = `${FilterTypes}`;

export enum FilterOperators {
    And = "and",
    Or = "or",
    Equals = "equals",
    NotEquals = "notEquals",
    Like = "like",
    NotLike = "notLike",
    ILike = "ilike",
    EndsWith = "endsWith",
    StartsWith = "startsWith",
    In = "in",
    NotIn = "not-in",
    Includes = "includes",
    NotIncludes = "not-includes",
    GreaterThan = "gt",
    LessThan = "lt",
    GreaterThanOrEqual = "gte",
    LessThanOrEqual = "lte",
    // // // //
    // Datetime operator aliases?
    Before = "before",
    OnOrBefore = "onOrBefore",
    After = "after",
    OnOrAfter = "onOrAfter",
    // Null operators
    IsNull = "is_null",
    IsNotNull = "is_not_null",
}
export type FilterOperator = `${FilterOperators}`;

// // // //

// // // //
// Define FilterMetadata interfaces

export interface Content {
    label: string;
    description?: string;
    documentation?: string;
    icon?: string;
}

export type SelectOptionValue = string | number;

export interface SelectOption {
    value: SelectOptionValue;
    content: Content;
}

// TODO - annotate this and make sure it's obvious how this is different from FilterDefinition below...
// i.e. - this is used by the frontend to build the UI for the filters, and FilterDefinition is used by the backend to ensure that SqlColumnTypes can only be paired with specific operators
export interface FilterMetadata {
    field: string;
    content: Content;
    type: FilterType;
    allowedOperators: FilterOperator[];
    defaultOperator: FilterOperator;
    defaultValue: string | number | boolean | string[] | null;
    displayInline: boolean; // NOTE - get rid of this if we're not going to functionally distinguish between basic & composite filtering? Or are we..?
    sortable?: boolean;
    selectOptions?: SelectOption[];
    category?: {
        label: string; // this is the label for category
        order: number; // use this to order the categories in the sidebar in FieldSelectPanel
        // resolve icon + color with getCatalogIconStyles from
        // "~/modules/catalog/lib/getCatalogIconStyles", or render them with the
        // CatalogIcon component
        icon: string | null;
        color: string;
        catalog_type: "metric" | "reference_data"; // Sort metric items above reference_data items
    };
}

// // // //
// ApiQueryEndpoints + ApiQueryView Interfaces

export enum ApiQueryEndpoints {
    // V4 Endpoints
    AssetV4 = "asset_v4",
    TokenV4 = "token_v4",
    NetworkV4 = "network_v4",
    PlatformV4 = "platform_v4",
    ProtocolV4 = "protocol_v4",
    IssuerV4 = "issuer_v4",
    ManagerV4 = "manager_v4",
    TransactionsV4 = "transactions_v4",
    ServiceProviderV4 = "service_provider_v4",
    AssetClassV4 = "asset_class_v4",
    AssetAggregatesV4 = "asset_aggregates_v4",
    AssetTimeseriesV4 = "asset_timeseries_v4",
    TokenTimeseriesV4 = "token_timeseries_v4",
    TokenAggregatesV4 = "token_aggregates_v4",
    TokenHoldersV4 = "token_holders_v4",
    MeasureV4 = "measure_v4",
    ReferenceDataV4 = "reference_data_v4",
}

export const API_QUERY_BASE_URLS: Record<ApiQueryEndpoints, string> = {
    // V4 Endpoints
    [ApiQueryEndpoints.AssetV4]: "/v4/assets",
    [ApiQueryEndpoints.TokenV4]: "/v4/tokens",
    [ApiQueryEndpoints.NetworkV4]: "/v4/networks",
    [ApiQueryEndpoints.PlatformV4]: "/v4/platforms",
    [ApiQueryEndpoints.ProtocolV4]: "/v4/protocols",
    [ApiQueryEndpoints.IssuerV4]: "/v4/issuers",
    [ApiQueryEndpoints.ManagerV4]: "/v4/managers",
    [ApiQueryEndpoints.TransactionsV4]: "/v4/transactions",
    [ApiQueryEndpoints.ServiceProviderV4]: "/v4/service_providers",
    [ApiQueryEndpoints.AssetClassV4]: "/v4/asset_classes",
    [ApiQueryEndpoints.AssetAggregatesV4]: "/v4/assets/aggregates",
    [ApiQueryEndpoints.AssetTimeseriesV4]: "/v4/assets/aggregates/timeseries",
    [ApiQueryEndpoints.TokenAggregatesV4]: "/v4/tokens/aggregates",
    [ApiQueryEndpoints.TokenTimeseriesV4]: "/v4/tokens/aggregates/timeseries",
    [ApiQueryEndpoints.TokenHoldersV4]: "/v4/tokens/holders",
    [ApiQueryEndpoints.MeasureV4]: "/v4/catalog/measures",
    [ApiQueryEndpoints.ReferenceDataV4]: "/v4/catalog/reference_data",
};

// NOTE - this is a temporary mapping to get the base URL for the Jupyter notebook code samples
// This is here because some of the Filters UI components don't use consume ApiQueryEndpoints as props,
// so instead we use this mapping to get the base URL for the Jupyter notebook code samples
// TODO - update this so it maps ApiQueryEndpoint to the correct notebook URL
// const CDN_URL = "https://cdn.rwa.xyz/notebooks";
// export const BASE_URL_TO_JUPYTER_NOTEBOOK_URL: Partial<Record<string, string>> =
//     {
//         // V3 Endpoints
//         // ["/v3/asset_reserves"]: `${CDN_URL}/rwa_xyz_asset_reserves_v3.ipynb`,
//         [API_QUERY_BASE_URLS[ApiQueryEndpoints.AssetAggregates]]:
//             `${CDN_URL}/rwa_xyz_asset_timeseries_v3.ipynb`,
//         [API_QUERY_BASE_URLS[ApiQueryEndpoints.Protocol]]:
//             `${CDN_URL}/rwa_xyz_protocols_v3.ipynb`,
//         [API_QUERY_BASE_URLS[ApiQueryEndpoints.Issuer]]:
//             `${CDN_URL}/rwa_xyz_issuers_v3.ipynb`,
//         [API_QUERY_BASE_URLS[ApiQueryEndpoints.Loan]]:
//             `${CDN_URL}/rwa_xyz_loans_v3.ipynb`,
//         [API_QUERY_BASE_URLS[ApiQueryEndpoints.TransactionsV4]]:
//             `${CDN_URL}/rwa_xyz_transactions_v3.ipynb`,
//         [API_QUERY_BASE_URLS[ApiQueryEndpoints.AssetTimeseries]]:
//             `${CDN_URL}/rwa_xyz_asset_timeseries_v3.ipynb`,
//         // V4 Endpoints
//         [API_QUERY_BASE_URLS[ApiQueryEndpoints.AssetV4]]:
//             `${CDN_URL}/rwa_xyz_assets_v4.ipynb`,
//         [API_QUERY_BASE_URLS[ApiQueryEndpoints.TokenV4]]:
//             `${CDN_URL}/rwa_xyz_tokens_v4.ipynb`,
//         [API_QUERY_BASE_URLS[ApiQueryEndpoints.NetworkV4]]:
//             `${CDN_URL}/rwa_xyz_networks_v4.ipynb`,
//         [API_QUERY_BASE_URLS[ApiQueryEndpoints.PlatformV4]]:
//             `${CDN_URL}/rwa_xyz_platforms_v4.ipynb`,
//         [API_QUERY_BASE_URLS[ApiQueryEndpoints.ProtocolV4]]:
//             `${CDN_URL}/rwa_xyz_protocols_v4.ipynb`,
//         [API_QUERY_BASE_URLS[ApiQueryEndpoints.ServiceProviderV4]]:
//             `${CDN_URL}/rwa_xyz_service_providers_v4.ipynb`,
//         [API_QUERY_BASE_URLS[ApiQueryEndpoints.AssetTimeseriesV4]]:
//             `${CDN_URL}/rwa_xyz_asset_timeseries_v4.ipynb`,
//         [API_QUERY_BASE_URLS[ApiQueryEndpoints.TokenTimeseriesV4]]:
//             `${CDN_URL}/rwa_xyz_token_timeseries_v4.ipynb`,
//         // [API_QUERY_BASE_URLS[ApiQueryEndpoints.AssetAggregatesV4]]: `${CDN_URL}/rwa_xyz_asset_aggregates_v4.ipynb`,
//         // [API_QUERY_BASE_URLS[ApiQueryEndpoints.TokenAggregatesV4]]: `${CDN_URL}/rwa_xyz_token_aggregates_v4.ipynb`,
//     };
